<template>
  <van-nav-bar
    :title="title"
    left-arrow
    fixed
    @click-left="onClickLeft"
  />
</template>
<script>
import { common } from './common/mixin.js'

export default {
  name: 'GoBack',
  mixins: [common],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    }
  }
}
</script>
